import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'
import { Calendar } from 'primeng/calendar'

@Component({
  selector: 'jml-lib-date-cell',
  templateUrl: './date-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class DateCellComponent extends InlineEditCellDirective implements OnInit {
  @Input() scrollableBody
  @Input() showTime
  @Input() tableReference: ElementRef
  @ViewChild('calendarRef') calendarRef: Calendar

  override minWidthPx = 80
  private keydownListener: ((e: KeyboardEvent) => void) | null = null

  //create custom localization for p-calendar component
  de: any

  ngOnInit(): void {
    //TODO: i18n verwenden! https://blog.ninja-squad.com/2019/12/10/angular-localize/
    this.de = {
      firstDayOfWeek: 1,
      dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      dayNamesMin: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
      monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Okotober',
        'November',
        'Dezember'
      ],
      monthNamesShort: ['Jan', 'Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      today: 'Heute',
      clear: 'Verwerfen'
    }
  }

  triggerEdit() {
    this.originalContent = this.rowData[this.fieldName]
    this.isEdited = true
    this.tableReference?.nativeElement
      .querySelector('div.p-datatable-scrollable-body')
      ?.addEventListener('scroll', (ev: Event) => this.abortCellEdit(null), { once: true })
    setTimeout(() => this.attachEnterKeyListener())
  }

  onDateSelect() {
    if (!this.showTime) {
      this.save()
    }
  }

  save() {
    if (!this.mandatory || this.rowData[this.fieldName]) {
      this.isEdited = false
      this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
    }
  }

  private attachEnterKeyListener() {
    if (this.calendarRef?.inputfieldViewChild?.nativeElement) {
      this.keydownListener = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
          this.save()
        }
      }

      this.calendarRef.inputfieldViewChild.nativeElement.addEventListener('keydown', this.keydownListener, true)
    }
  }
}
